import {useCallback} from 'react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

/**
 * Returns the `buildUrl` option for `parseShortcodes`, which prefixes internal
 * shortcode link hrefs (`page`, `product`, `category` and relative `url`) with
 * the current site/locale, e.g. `/privacy.html` → `/us/privacy.html`.
 *
 * Paths already starting with the current site or locale segment are left
 * untouched so authored URLs never get a duplicated prefix.
 *
 * @returns {function(string): string}
 */
export const useShortcodeLinkUrl = () => {
    const {site, locale, buildUrl} = useMultiSite() || {}

    return useCallback(
        (path) => {
            if (typeof buildUrl !== 'function' || typeof path !== 'string') return path
            if (!path.startsWith('/')) return path

            const firstSegment = path.split('?')[0].split('/')[1]
            const existingPrefixes = [site?.id, site?.alias, locale?.id, locale?.alias].filter(
                Boolean
            )
            if (firstSegment && existingPrefixes.includes(firstSegment)) return path

            return buildUrl(path)
        },
        [buildUrl, site?.id, site?.alias, locale?.id, locale?.alias]
    )
}

export default useShortcodeLinkUrl
